var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#0F141F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5245 9.46353C19.6741 9.00287 20.3259 9.00287 20.4755 9.46353L22.5819 15.9463C22.6488 16.1523 22.8408 16.2918 23.0574 16.2918H29.8738C30.3582 16.2918 30.5596 16.9116 30.1677 17.1963L24.6531 21.2029C24.4779 21.3302 24.4046 21.5559 24.4715 21.7619L26.5779 28.2447C26.7276 28.7053 26.2003 29.0884 25.8085 28.8037L20.2939 24.7971C20.1186 24.6698 19.8814 24.6698 19.7061 24.7971L14.1915 28.8037C13.7997 29.0884 13.2724 28.7053 13.4221 28.2447L15.5285 21.7619C15.5954 21.5559 15.5221 21.3302 15.3469 21.2029L9.83227 17.1963C9.44041 16.9116 9.6418 16.2918 10.1262 16.2918H16.9426C17.1592 16.2918 17.3512 16.1523 17.4181 15.9463L19.5245 9.46353Z",
    fill: "url(#paint0_linear_249_359)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_249_359",
    x1: 30.2857,
    y1: 10.1818,
    x2: 10.1818,
    y2: 30.4416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5390E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1357B3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.c68731cf8b8cff03a32e714c34ebd578.svg";
export { ForwardRef as ReactComponent };